import React, {useEffect, useState, useRef} from "react";
import {connect, useSelector} from "react-redux";

export function Info(props) {

const [isHovered, setIsHovered] = useState(false);
const [renderInfo, setRenderInfo] = useState(false);
const [infoIsOpaque, setInfoIsOpaque] = useState(false);
const [alignment, setAlignment] = useState("");

const maxX = window.innerWidth - 154;
const minX = 154;

const hoverRef = useRef(isHovered)
hoverRef.current = isHovered;

useEffect(() => {

    if (isHovered) {
        setTimeout(() => {
            if (hoverRef.current) {
                setRenderInfo(true);
                setTimeout(() => setInfoIsOpaque(true), 50);
            }
        }, 500);
    }
    else {
        infoIsOpaque && setInfoIsOpaque(false);
        renderInfo && setTimeout(() => setRenderInfo(false), 300);

    }
}, [isHovered]);

const info = 
<div className={`info-wrapper ${infoIsOpaque?"show":"hide"}`}>
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        transform="rotate(45)"
        className="card-lip"
        fill="#2A292D" 
    >
        <rect width="12" height="12" ></rect>
    </svg>
    <div className={`info-card content2 multiline g8-text ${alignment}`} >
        {props.heading && <><div className="heavy g9-text gap-below-xxs">{props.heading}</div></>}
        {props.children}
    </div>
</div>

const icon =  
    <div className={`iblock info-icon ${props.className}`} id="info"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{cursor: 'help'}}
            ref={el => {
                if (!el) return;
                if (el.getBoundingClientRect().x > maxX) {
                    setAlignment("near-right");
                } else if (el.getBoundingClientRect().x < minX) {
                    setAlignment("near-left");
                } else setAlignment("");
            }}
        >
        <div className="iblock">
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width={props.size ? props.size : "16"} 
                height={"16"} 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#919197" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                className="info icon gap-left-xxs">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12" y2="8"></line>
            </svg>
        </div>
        {renderInfo && info}
    </div> 

    return (
        <>{icon}</>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(Info);